/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  DatePicker,
  Select,
  Upload,
  message,
  Checkbox,
  Switch,
  Popover,
  Divider,
  Tooltip,
  Modal,
  Radio,
} from 'antd';
import { uniqBy } from 'lodash';
import { UploadProps } from 'antd/lib/upload';
import IconButton from '~components/_common/IconButton/IconButton';
import { useCurrentFolder } from '~src/hooks/useCurrentFolder';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import UploadContext from '~src/contexts/UploadContext';
import FilterRecentContext, {
  FilterRecentContextType,
  getDefaultFilterRecent,
} from '~src/contexts/FilterRecentContext';
import { useIsPath } from '~src/hooks/useIsPath';
import { FileX } from '~src/types/upload';
import { RIGHTS_LEVEL } from '~src/types/enums';
import { useCurrentTemplate } from '~src/hooks/useCurrentTemplate';
import { useIsSuperuser } from '~src/hooks/useIsSuperuser';
import { useIntl } from 'react-intl';
import { CreateFolderModal } from '~components/popups-modals/CreateFolder.modal';
import { CreateTenderModal } from './Modals/CreateTenderModal';
import moment, { DurationInputArg1, unitOfTime } from 'moment';
import { DbFocusOptions } from '~src/types/db';
import _ from 'lodash';
import { NavIcon } from '~components/_common/NavIcon/NavIcon';
import ModuleTenderHammerColor from '~src/assets/nav-icons/module-tender-hammer-color.svg';
import { useTenderFoldersFolders } from '~src/hooks/api-hooks/useTenderFoldersFolders';
import { useHistory } from 'react-router-dom';
import FolderTender from '~src/assets/nav-icons/folder-tender.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FolderTenderHammer from '~src/assets/nav-icons/folder-tender-hammer.svg';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import doReturnTheme from '~src/styles/themeEngine';
import { useProjectId } from '~src/hooks/useProjectId';
import { styleFn } from './RightSideNav.style';
import { SearchContext } from '~src/contexts/SearchContext';
import { MODULES } from '~src/types/enums';
import { useStore } from '~src/store';
import { useModules } from '~src/hooks/api-hooks/useModules';
import TasksDa from '~src/assets/nav-icons/tasks-da.png';
import TasksEn from '~src/assets/nav-icons/tasks-en.png';
import EnquieriesDa from '~src/assets/nav-icons/enquieries-da.png';
import EnquieriesEn from '~src/assets/nav-icons/enquieries-en.png';
import SupervisionDa from '~src/assets/nav-icons/supervision-da.png';
import SupervisionEn from '~src/assets/nav-icons/supervision-en.png';
import ControlDa from '~src/assets/nav-icons/control-da.png';
import ControlEn from '~src/assets/nav-icons/control-en.png';
import Comissioning from '~src/assets/nav-icons/commissioning-en.png';
import EconomicsDa from '~src/assets/nav-icons/economics-da.png';
import EconomicsEn from '~src/assets/nav-icons/economics-en.png';
import FacilityManagementDa from '~src/assets/nav-icons/facility-management-da.png';
import FacilityManagementEn from '~src/assets/nav-icons/facility-management-en.png';
import { LANGUAGE } from '~src/config';
import { useModalActions } from '~src/contexts/ModalsContext';
import { ProjectBuilderHelpInfoModal } from '~components/popups-modals/ProjectBuilderHelpInfo.modal';

enum LimitType {
  FIFTY = 50,
  HUNDRED = 100,
  TWO_HUNDRED = 200,
  FOUR_HUNDRED = 400,
}

type OptionType = {
  value: number;
  label: number;
};

type OptionDate = {
  unit: unitOfTime.DurationConstructor;
  amount: DurationInputArg1;
  label: string;
};

interface RightSideNavProps {
  focusOptions?: DbFocusOptions[];
  isUnassignedItemsVisible?: boolean;
  onChangeIsUnassignedTenderFolders?: () => void;
}

//initial state for filter recent page
const initialFilterRecentStateValue: FilterRecentContextType = getDefaultFilterRecent();

const RightSideNav: React.FC<RightSideNavProps> = ({
  focusOptions,
  isUnassignedItemsVisible,
  onChangeIsUnassignedTenderFolders,
}) => {
  const { Option } = Select;

  const selectOptions: OptionType[] = [
    {
      value: LimitType.FIFTY,
      label: LimitType.FIFTY,
    },
    {
      value: LimitType.HUNDRED,
      label: LimitType.HUNDRED,
    },
    {
      value: LimitType.TWO_HUNDRED,
      label: LimitType.TWO_HUNDRED,
    },
    {
      value: LimitType.FOUR_HUNDRED,
      label: LimitType.FOUR_HUNDRED,
    },
  ];

  const dateOptions: OptionDate[] = [
    {
      unit: 'd',
      amount: 7,
      label: '1 week',
    },
    {
      unit: 'd',
      amount: 14,
      label: '2 weeks',
    },
    {
      unit: 'months',
      amount: 1,
      label: '1 month',
    },
  ];

  // JIRA: TV1-332
  const {
    tenderFilterStates,
    addToTenderFilter,
    removeFromTenderFilter,
    setAllTenderSelected,
    removeAllTenderSelected,
    tenderIncludeDeletedState,
    setTenderIncludeDeletedState,
    moduleFilterStates,
    addToModuleFilter,
    removeFromModuleFilter,
    setAllModulesSelected,
    removeAllModulesSelected,
    registrationFileFilter,
    setRegistrationFileFilter,
  } = useStore();

  const style = useStyles(styleFn);
  const intl = useIntl();
  const history = useHistory();
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);

  const projectId = useProjectId();

  const isOnDocuments = useIsPath('/documents');
  const isOnTenderUnassgine = useIsPath('/tender-folders') && !isOnDocuments;
  const root_folder_id = history.location.pathname
    .split('/')
    .filter(Boolean)[3];
  const foldersQuery = useTenderFoldersFolders(
    {
      root_folder_id,
    },
    { enabled: isOnTenderUnassgine }
  );
  const currentFolder = useCurrentFolder(
    isOnTenderUnassgine ? foldersQuery.data : null
  );

  const currentTemplate = useCurrentTemplate();

  const { setUploadContext } = useContext(UploadContext);
  const { setFilterRecentContext } = useContext(FilterRecentContext);
  const searchContext = useContext(SearchContext);

  const showFileBtn = !useIsPath('/archive', { endsWith: true });
  const isOnArchive = useIsPath('/archive');
  const isOnTender = useIsPath('/tenders');
  const isOnRecents = useIsPath('/recents');
  const isOnTemplates = useIsPath('/templates');
  const isOnProjectBuilder = useIsPath('/project-builder');
  const isOnSectorRegistrations = useIsPath('/section-modules/sector');
  const isOnIndividualModule = useIsPath('/module/');
  const isSuperuser = useIsSuperuser();
  const projectBuilderModal = useModalActions('projectBuilderModal');
  const importTemplateModal = useModalActions('importTemplateModal');
  const isOnRoot = useIsPath('/archive', { endsWith: true });
  const isOnTenderRegistration = useIsPath('/tenders', { endsWith: true });

  const modulesQuery = useModules({});

  const permissionLevel = isOnTenderUnassgine
    ? 2
    : currentFolder?.permission || 0;

  const optionFolder = currentFolder?.option;

  const [createTenderModalVisible, setCreateTenderModalVisible] = useState(
    false
  );
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [newFoldersCount, setNewFoldersCount] = useState(0);
  const [duplicateFoldersCount, setDuplicateFoldersCount] = useState(0);
  const [
    isHelpProjectBuilderModalVisible,
    setHelpProjectBuilderModalVisible,
  ] = useState(false);
  const [selectValue, setSelectValue] = useState(
    getDefaultFilterRecent().limit
  );
  const [filterRecent, setFilterRecent] = useState<FilterRecentContextType>(
    initialFilterRecentStateValue
  );

  const hasSearchQuery = Boolean(
    searchContext?.query && String(searchContext.query).trim()
  );
  const searchQueryText = hasSearchQuery
    ? String(searchContext.query).trim()
    : '';

  // Listen for new folders count changes from RightSideViewProjectBuilder
  useEffect(() => {
    const handleCountChange = (event: CustomEvent) => {
      setNewFoldersCount(event.detail.count);
    };

    window.addEventListener(
      'newFoldersCountChanged',
      handleCountChange as EventListener
    );
    return () => {
      window.removeEventListener(
        'newFoldersCountChanged',
        handleCountChange as EventListener
      );
    };
  }, []);

  // Listen for duplicate folders count changes from RightSideViewProjectBuilder
  useEffect(() => {
    const handleDuplicateCountChange = (event: CustomEvent) => {
      setDuplicateFoldersCount(event.detail.count);
    };

    window.addEventListener(
      'projectBuilderDuplicateCount',
      handleDuplicateCountChange as EventListener
    );
    return () => {
      window.removeEventListener(
        'projectBuilderDuplicateCount',
        handleDuplicateCountChange as EventListener
      );
    };
  }, []);

  const handleUploadChange: UploadProps['onChange'] = (info) => {
    setUploadContext((prevFiles) => {
      const file = info.fileList.find((v) => v.uid === info.file.uid)
        ?.originFileObj as FileX | undefined;
      if (!file) return prevFiles;

      return uniqBy(
        [file, ...prevFiles],
        (v) =>
          `${v.name}@${
            v.webkitRelativePath === v.name ? '' : v.webkitRelativePath
          }`
      );
    });
  };

  const handleSyncFolders = () => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'sync-folders-confirm-title' }),
      content: intl.formatMessage({ id: 'sync-folders-confirm-content' }),
      okText: intl.formatMessage({ id: 'ok' }),
      cancelText: intl.formatMessage({ id: 'cancel' }),
      onOk: () => {
        window.dispatchEvent(new CustomEvent('syncProjectBuilderFolders'));
      },
    });
  };

  const handleMergeFolders = () => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'merge-folders-confirm-title' }),
      content: intl.formatMessage(
        { id: 'merge-folders-confirm-content' },
        { count: duplicateFoldersCount }
      ),
      okText: intl.formatMessage({ id: 'merge' }),
      cancelText: intl.formatMessage({ id: 'cancel' }),
      onOk: () => {
        window.dispatchEvent(new CustomEvent('mergeDuplicateFolders'));
      },
    });
  };

  // Module filter handlers
  const handleModuleToggle = (moduleId: number) => {
    if (moduleFilterStates.includes(moduleId)) {
      removeFromModuleFilter(moduleId);
    } else {
      addToModuleFilter(moduleId);
    }
  };

  const MODULE_NAME_MAP: Record<number, string> = {
    [MODULES.TASK]: 'task',
    [MODULES.TQ]: 'technical_question',
    [MODULES.SUPV]: 'supervision',
    [MODULES.CONT]: 'control',
    [MODULES.COM]: 'commissioning',
    [MODULES.DV]: 'd_and_v',
    [MODULES.AFTS]: 'afts',
    [MODULES.ECO]: 'eco',
  };

  const moduleFilterOptions = [
    {
      id: MODULES.TASK,
      label: intl.formatMessage({ id: 'tasks' }),
      customIcon: LANGUAGE.startsWith('da') ? TasksDa : TasksEn,
    },
    {
      id: MODULES.TQ,
      label: intl.formatMessage({ id: 'enquiries' }),
      customIcon: LANGUAGE.startsWith('da') ? EnquieriesDa : EnquieriesEn,
    },
    {
      id: MODULES.SUPV,
      label: intl.formatMessage({ id: 'supervision' }),
      customIcon: LANGUAGE.startsWith('da') ? SupervisionDa : SupervisionEn,
    },
    {
      id: MODULES.CONT,
      label: intl.formatMessage({ id: 'control' }),
      customIcon: LANGUAGE.startsWith('da') ? ControlDa : ControlEn,
    },
    {
      id: MODULES.COM,
      label: intl.formatMessage({ id: 'commissioning' }),
      customIcon: Comissioning,
    },
    {
      id: MODULES.DV,
      label: intl.formatMessage({ id: 'facility-management' }),
      customIcon: LANGUAGE.startsWith('da')
        ? FacilityManagementDa
        : FacilityManagementEn,
    },
    {
      id: MODULES.AFTS,
      label: intl.formatMessage({ id: 'contract' }),
      customIcon: null,
    },
    {
      id: MODULES.ECO,
      label: intl.formatMessage({ id: 'economics' }),
      customIcon: LANGUAGE.startsWith('da') ? EconomicsDa : EconomicsEn,
    },
  ];

  const enabledModuleFilterOptions = moduleFilterOptions.filter((option) => {
    const moduleName = MODULE_NAME_MAP[option.id];
    return moduleName && modulesQuery.data?.[moduleName];
  });

  const allModulesSelected =
    enabledModuleFilterOptions.length > 0 &&
    enabledModuleFilterOptions.every((option) =>
      moduleFilterStates.includes(option.id)
    );
  const someModulesSelected =
    enabledModuleFilterOptions.some((option) =>
      moduleFilterStates.includes(option.id)
    ) && !allModulesSelected;

  const handleAllModulesToggle = () => {
    if (allModulesSelected) {
      // Remove all enabled modules from filter
      enabledModuleFilterOptions.forEach((option) => {
        if (moduleFilterStates.includes(option.id)) {
          removeFromModuleFilter(option.id);
        }
      });
    } else {
      // Add all enabled modules to filter
      enabledModuleFilterOptions.forEach((option) => {
        if (!moduleFilterStates.includes(option.id)) {
          addToModuleFilter(option.id);
        }
      });
    }
  };

  let showCreateFolderBtn = false;

  if (!isOnRoot) {
    showCreateFolderBtn = permissionLevel >= RIGHTS_LEVEL.WRITE;
  } else if (isSuperuser) {
    showCreateFolderBtn = true;
  }

  const uploadFileAllowed =
    window.sessionStorage.getItem('appState') !== 'timeMachine' &&
    window.sessionStorage.getItem('appState') !== 'superUser' &&
    permissionLevel >= RIGHTS_LEVEL.UPLOAD;
  const uploadFolderAllowed =
    window.sessionStorage.getItem('appState') !== 'timeMachine' &&
    window.sessionStorage.getItem('appState') !== 'superUser' &&
    permissionLevel >= RIGHTS_LEVEL.WRITE;
  const readOnlyStatus = permissionLevel === RIGHTS_LEVEL.OPEN;
  const submitOnlyStatus = permissionLevel === RIGHTS_LEVEL.UPLOAD;
  const fullAccessOnlyStatus = permissionLevel >= RIGHTS_LEVEL.MANAGE;

  const updateLimitType = (option: number) => {
    setSelectValue(option);
    setFilterRecent({
      ...filterRecent,
      limit: option,
    });
    setFilterRecentContext({
      ...filterRecent,
      limit: option,
    });
    if (option === 50) {
      window.sessionStorage.removeItem('limitRecent');
    } else {
      window.sessionStorage.setItem('limitRecent', option.toString());
    }
  };

  const updateAfterDate = (value: number | undefined) => {
    setFilterRecent({
      ...filterRecent,
      afterDate: value,
    });
    setFilterRecentContext({
      ...filterRecent,
      afterDate: value,
    });
  };

  const disabledDate = (current) => {
    // Can not select days after today
    return current && current > moment();
  };

  const onClickDateOptions = (el: OptionDate) => {
    const { amount, unit } = el;
    updateAfterDate(
      moment()
        .subtract(amount, unit)
        .set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        })
        .valueOf()
    );
    if (amount === 14) {
      window.sessionStorage.removeItem('afterDateRecent');
    } else {
      window.sessionStorage.setItem('afterDateRecent', unit);
    }
  };

  const getBackgroundComponent = () => {
    return `#${
      currentFolder && currentFolder.focus
        ? _.find(focusOptions, {
            value: currentFolder.focus,
          })?.color_hex_code
        : ''
    }`;
  };

  // JIRA: TV1-332 - Updated to include Processed (7)
  const tenderStateFilterAll = [1, 3, 6, 7];

  const handleTenderStateCheckboxChange = (id: number, checked: boolean) => {
    checked ? addToTenderFilter(id) : removeFromTenderFilter(id);
  };

  // Styles exactly matching TenderTabs.styles.ts
  const popupStyles = {
    filterWrapper: {
      gap: '5px',
      display: 'flex',
      flexDirection: 'column' as const,
      justifyContent: 'center',
      margin: '0 15px',
      paddingBottom: '10px',
    },
    filterIconWrapper: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      gap: '10px',
    },
    filterItemWrapper: {
      display: 'flex',
      flexDirection: 'row' as const,
      justifyContent: 'space-between',
      gap: 20,
    },
    radioSection: {
      padding: '12px 0',
      borderTop: '1px solid #e5e7eb',
      marginTop: '8px',
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: 6,
      width: '100%',
    },
    radioOption: {
      fontSize: 13,
      fontWeight: 500,
      color: '#374151',
      padding: '4px 0',
      margin: 0,
      '&:hover': {
        color: '#2563eb',
      },
      '& .ant-radio': {
        marginRight: 8,
      },
      '& .ant-radio-checked .ant-radio-inner': {
        borderColor: '#2563eb',
        background: '#2563eb',
      },
    },
  };

  const tenderFilterContent = (
    <div css={popupStyles.filterWrapper}>
      <div css={popupStyles.filterItemWrapper}>
        <div css={popupStyles.filterIconWrapper}>
          {intl.formatMessage({ id: 'show-all' })}
        </div>
        <Checkbox
          checked={tenderFilterStates.length === tenderStateFilterAll.length}
          onChange={(e) =>
            e.target.checked
              ? setAllTenderSelected()
              : removeAllTenderSelected()
          }
        />
      </div>

      {[
        {
          id: 1,
          labelId: 'tender_state_draft',
          color: 'grey',
          icon: 'stopwatch', // Awaiting icon
        },
        {
          id: 3,
          labelId: 'tender_state_active',
          color: 'green',
          icon: 'check-circle', // Green checkmark
        },
        {
          id: 6,
          labelId: 'tender_state_closed', // Completed
          color: 'red',
          icon: 'check-circle', // Red checkmark
        },
        // {
        //   id: 7,
        //   labelId: 'tender_state_processed',
        //   color: 'red',
        //   icon: 'check-circle', // Red checkmark
        // },
      ].map(({ id, labelId, color, icon }) => (
        <div key={id} css={popupStyles.filterItemWrapper}>
          <div css={popupStyles.filterIconWrapper}>
            <FontAwesomeIcon
              // @ts-ignore
              icon={['far', icon]}
              style={{ color }}
            />
            {intl.formatMessage({ id: labelId })}
          </div>
          <Checkbox
            checked={tenderFilterStates.includes(id)}
            onChange={(e) =>
              handleTenderStateCheckboxChange(id, e.target.checked)
            }
          />
        </div>
      ))}
      <Divider css={{ margin: '3px 0px 0px 0px', padding: 0 }} />
      {/* Single "show deleted" checkbox - Gray Bin */}
      <div css={popupStyles.filterItemWrapper}>
        <div css={popupStyles.filterIconWrapper}>
          <FontAwesomeIcon
            icon={['far', 'trash']}
            style={{ color: 'grey' }} // Gray bin
          />
          {intl.formatMessage({ id: 'show-deleted' })}
        </div>
        <Checkbox
          checked={tenderIncludeDeletedState}
          onChange={(e) => setTenderIncludeDeletedState(e.target.checked)}
        />
      </div>
    </div>
  );

  return isOnTender &&
    !isOnTenderRegistration &&
    !isOnTenderUnassgine ? null : (
    <div
      css={[
        style.component,
        {
          background: getBackgroundComponent(),
          color:
            currentFolder &&
            currentFolder.focus &&
            window.sessionStorage.getItem('appState') === 'timeMachine'
              ? 'black'
              : theme.colors.text.primary,
        },
      ]}>
      {isOnTender && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}>
          <NavIcon
            customStyle={{ width: '45px', height: '22px' }}
            icon={ModuleTenderHammerColor}
          />
          <div css={style.headline}>{intl.formatMessage({ id: 'tender' })}</div>
          {hasSearchQuery && (
            <div
              css={{
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: 12,
                padding: '2px 0px',
                fontSize: 13,
                color: '#70757a',
              }}>
              <IconButton
                iconStyle="far"
                icon="search"
                customStyle={{
                  fontSize: '11px',
                  marginRight: 6,
                  opacity: 0.5,
                }}
                backgroundOff
              />
              <span css={{ marginRight: 4, opacity: 0.7 }}>
                {intl.formatMessage({ id: 'searching-for' })}
              </span>
              <span css={{ fontWeight: 600, color: '#1a73e8' }}>
                {searchQueryText}
              </span>
            </div>
          )}

          <div css={{ display: 'flex', marginLeft: 'auto' }}>
            {/* JIRA: TV1-332 */}
            {isOnTenderRegistration && (
              <Popover
                placement="bottomRight"
                content={tenderFilterContent}
                trigger="click">
                <div css={style.buttonDiv}>
                  <IconButton
                    iconStyle="far"
                    icon="filter-list"
                    customStyle={style.icons}
                    backgroundOff
                  />
                  <p css={{ marginBottom: 0, marginLeft: 2 }}>
                    {intl.formatMessage({ id: 'filters' })}
                  </p>
                </div>
              </Popover>
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
              }}>
              <div
                css={style.buttonDiv}
                onClick={() => setCreateTenderModalVisible(true)}>
                <IconButton
                  iconStyle="far"
                  icon="file-plus"
                  customStyle={style.icons}
                  backgroundOff
                />
                <p css={{ marginBottom: 0, marginLeft: 2 }}>
                  {intl.formatMessage({ id: 'create-tender' })}
                </p>
              </div>
              <div
                css={Object.assign(
                  {},
                  style.buttonDiv,
                  isUnassignedItemsVisible && style.buttonDivActive
                )}
                onClick={onChangeIsUnassignedTenderFolders}>
                <IconButton
                  iconStyle="far"
                  icon="grid-dividers"
                  customStyle={style.icons}
                  backgroundOff
                />
                <p css={{ marginBottom: 0, marginLeft: 2 }}>
                  {intl.formatMessage({ id: 'show-folder-tab' })}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {(isOnArchive || isOnTenderUnassgine) && (
        <Fragment>
          {currentFolder && (
            <Fragment>
              {readOnlyStatus && (
                <IconButton
                  iconStyle={'fas'}
                  icon={'lock'}
                  color={'darkGray'}
                  customStyle={{ fontSize: '15px' }}
                  backgroundOff
                />
              )}

              {isOnTenderUnassgine || optionFolder?.is_tender_folder ? (
                <NavIcon
                  customStyle={{ height: '50%' }}
                  icon={
                    currentFolder?.options?.is_tender_root_folder
                      ? FolderTenderHammer
                      : FolderTender
                  }
                />
              ) : (
                <IconButton
                  iconStyle={'fas'}
                  icon={'folder'}
                  color={'yellow'}
                  customStyle={style.icons}
                  backgroundOff
                />
              )}
            </Fragment>
          )}
          <div css={style.headline}>
            {currentFolder &&
              (isOnTenderUnassgine
                ? currentFolder.name
                : currentFolder.name || 'Unknown')}
          </div>

          <div css={{ display: 'flex', marginLeft: 'auto' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
              }}>
              {showCreateFolderBtn &&
                window.sessionStorage.getItem('appState') !== 'timeMachine' &&
                window.sessionStorage.getItem('appState') !== 'superUser' && (
                  <div
                    css={style.buttonDiv}
                    onClick={() => setCreateModalVisible(true)}>
                    <IconButton
                      iconStyle="far"
                      icon="folder-plus"
                      customStyle={style.icons}
                      backgroundOff
                    />
                    <p css={{ marginBottom: 0, marginLeft: 2 }}>
                      {intl.formatMessage({ id: 'create-folder' })}
                    </p>
                  </div>
                )}

              {currentFolder && readOnlyStatus && !fullAccessOnlyStatus && (
                <div css={style.buttonDiv}>
                  <p css={{ marginBottom: 0, marginLeft: 2 }}>
                    <b>{intl.formatMessage({ id: 'read-only' })}</b>
                  </p>
                  <IconButton
                    color="darkGray"
                    icon={['far', 'info-circle']}
                    customStyle={style.icons}
                    backgroundOff
                    tooltip={intl.formatMessage({ id: 'read-only-hover' })}
                  />
                </div>
              )}

              {uploadFileAllowed && showFileBtn && (
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={handleUploadChange}>
                  <div css={style.buttonDiv}>
                    <IconButton
                      iconStyle="far"
                      icon="file-upload"
                      customStyle={style.icons}
                      backgroundOff
                    />
                    <p>{intl.formatMessage({ id: 'upload-files' })}</p>
                  </div>
                </Upload>
              )}

              {currentFolder && submitOnlyStatus && !fullAccessOnlyStatus && (
                <div css={style.buttonDiv}>
                  <p css={{ marginBottom: 0, marginLeft: 2 }}>
                    <b>{intl.formatMessage({ id: 'submit-only' })}</b>
                  </p>
                  <IconButton
                    color="darkGray"
                    icon={['far', 'info-circle']}
                    customStyle={style.icons}
                    backgroundOff
                    tooltip={intl.formatMessage({ id: 'submit-only-hover' })}
                  />
                </div>
              )}

              {uploadFolderAllowed && (
                <Upload
                  multiple
                  directory
                  beforeUpload={() => false}
                  onChange={handleUploadChange}>
                  <div css={style.buttonDiv}>
                    <IconButton
                      iconStyle="far"
                      icon="folder-upload"
                      customStyle={style.icons}
                      backgroundOff
                    />
                    <p css={{ marginLeft: 5 }}>
                      {intl.formatMessage({ id: 'upload-folder' })}
                    </p>
                  </div>
                </Upload>
              )}
            </div>
          </div>
        </Fragment>
      )}

      {(isOnSectorRegistrations || isOnIndividualModule) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
          }}>
          <Popover
            placement="bottomRight"
            content={
              <div css={popupStyles.filterWrapper}>
                {isOnSectorRegistrations && (
                  <div>
                    <div css={popupStyles.filterItemWrapper}>
                      <div css={popupStyles.filterIconWrapper}>
                        {intl.formatMessage({ id: 'show-all' })}
                      </div>
                      <Checkbox
                        onChange={handleAllModulesToggle}
                        checked={allModulesSelected}
                        indeterminate={someModulesSelected}
                      />
                    </div>
                    {enabledModuleFilterOptions.map(
                      ({ id, label, customIcon }) => (
                        <div css={popupStyles.filterItemWrapper} key={id}>
                          <div css={popupStyles.filterIconWrapper}>
                            {customIcon ? (
                              <NavIcon
                                icon={customIcon}
                                customStyle={{ height: '20px', width: 'auto' }}
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={['fad', 'question-square']}
                                style={{ color: 'gray' }}
                              />
                            )}
                            {label}
                          </div>
                          <Checkbox
                            checked={moduleFilterStates.includes(id)}
                            onChange={() => handleModuleToggle(id)}
                          />
                        </div>
                      )
                    )}
                  </div>
                )}

                <div css={popupStyles.radioSection}>
                  <Radio.Group
                    value={registrationFileFilter}
                    onChange={(e) => setRegistrationFileFilter(e.target.value)}
                    css={popupStyles.radioGroup}>
                    <Radio value="all" css={popupStyles.radioOption}>
                      {intl.formatMessage({ id: 'show-all-registrations' })}
                    </Radio>
                    <Radio value="files-only" css={popupStyles.radioOption}>
                      {intl.formatMessage({ id: 'show-only-files' })}
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
            }
            trigger="click">
            <div css={style.buttonDiv}>
              <IconButton
                iconStyle="far"
                icon="filter-list"
                customStyle={style.icons}
                backgroundOff
              />
              <p css={{ marginBottom: 0, marginLeft: 2 }}>
                {intl.formatMessage({ id: 'filter' })}
              </p>
            </div>
          </Popover>
        </div>
      )}

      {isOnRecents && (
        <div
          style={{
            display: 'flex',
          }}>
          <p css={{ margin: '14px' }}>
            {intl.formatMessage({ id: 'recents-filter-from' })}
          </p>
          <DatePicker
            css={{ height: '32px', alignSelf: 'center' }}
            showToday={false}
            renderExtraFooter={() => {
              return (
                <div
                  style={{ display: 'flex', justifyContent: 'space-around' }}>
                  {dateOptions.map((el) => (
                    <a
                      key={`${el.unit}_${el.label}`}
                      onClick={() => onClickDateOptions(el)}
                      className="ant-picker-today-btn"
                      aria-disabled="false">
                      {el.label}
                    </a>
                  ))}
                </div>
              );
            }}
            disabledDate={disabledDate}
            value={
              filterRecent.afterDate ? moment(filterRecent?.afterDate) : null
            }
            onChange={(value) => {
              updateAfterDate(
                value
                  ?.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                  .valueOf() || undefined
              );
            }}
          />
          <p css={{ margin: '14px' }}>
            {intl.formatMessage({ id: 'recents-filter-max' })}
          </p>
          <Select
            // size="large"
            onChange={updateLimitType}
            // defaultValue={selectOptions[0].value}
            css={style.selectMenu}
            value={selectValue}>
            {selectOptions.map((el) => (
              <Option key={`${el.value}_${el.label}`} value={el.value}>
                {el.label}
              </Option>
            ))}
          </Select>
          <IconButton
            iconStyle="far"
            icon="info-circle"
            customStyle={style.icons}
            containerStyle={{ marginLeft: 'auto' }}
            backgroundOff
            tooltip={
              intl.locale === 'da' ? (
                <div>
                  <h3 css={style.whiteHeader}>
                    Seneste ændringer på projektet
                  </h3>
                  <p>
                    Denne side viser de seneste ændringer der er foretaget på
                    projektets filer.
                    <br />
                    Siden vil vise et valgt antal emner på listen fra et valgt
                    tidsrum.
                  </p>
                  <p>
                    Der kan ved hjælp af valgmulighederne bestemmes hvilken
                    periode der ønskes at ses ændringer fra, samt et ønsket
                    antal.
                  </p>
                  <p>
                    <b>Information</b>
                    <br />
                    Valg af periode vil blive husket til næste gang siden
                    besøges.
                  </p>
                </div>
              ) : (
                <div>
                  <h3 css={style.whiteHeader}>
                    Most recent changes on the project
                  </h3>
                  <p>
                    This page will show the most recent changes to the files on
                    the project.
                    <br />
                    The list can be adjusted with the filers by selecting
                    another timespan and/or the amount of results.
                  </p>
                  <p>
                    <b>Information</b>
                    <br />
                    The selected time period from the date selector will be
                    remembered for the next time you visit the page.
                  </p>
                </div>
              )
            }
            widthTooltip="500px"
          />
        </div>
      )}
      {isOnTemplates && (
        <div css={style.headline}>
          {currentTemplate && (currentTemplate.name || 'Unknown')}
        </div>
      )}
      {isOnProjectBuilder && (
        <Fragment>
          <div css={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* SAVE BUTTON */}
            <Tooltip
              title={
                newFoldersCount === 0
                  ? intl.formatMessage({ id: 'no-folders-to-reorganize' })
                  : duplicateFoldersCount > 0
                  ? intl.formatMessage(
                      { id: 'duplicate-folders-error' },
                      { count: duplicateFoldersCount }
                    )
                  : ''
              }
              placement="bottom">
              <div
                css={[
                  style.buttonDiv,
                  {
                    backgroundColor:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? '#f5f5f5'
                        : 'rgba(82, 196, 26, 0.08)',
                    border:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? '1px solid #d9d9d9'
                        : '1px solid #52c41a',
                    borderRadius: '4px',
                    padding: '1px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    opacity:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? 0.5
                        : 1,
                    cursor:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? 'not-allowed'
                        : 'pointer',
                    pointerEvents:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? 'none'
                        : 'auto',
                  },
                ]}
                onClick={() => {
                  if (newFoldersCount > 0 && duplicateFoldersCount === 0) {
                    handleSyncFolders();
                  }
                }}>
                <IconButton
                  iconStyle="far"
                  icon="repeat"
                  customStyle={{
                    color:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? '#8c8c8c'
                        : '#52c41a',
                    fontSize: '14px',
                  }}
                  backgroundOff
                />
                <p
                  css={{
                    marginBottom: 0,
                    color:
                      newFoldersCount === 0 || duplicateFoldersCount > 0
                        ? '#8c8c8c'
                        : '#52c41a',
                    fontSize: '13.5px',
                    fontWeight: 500,
                  }}>
                  {intl.formatMessage({ id: 'save' })}
                </p>
              </div>
            </Tooltip>
            {/* MERGE BUTTON */}
            {duplicateFoldersCount > 0 && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'merge-duplicate-folders-tooltip',
                })}
                placement="bottom">
                <div
                  css={[
                    style.buttonDiv,
                    {
                      backgroundColor: 'rgba(255, 77, 79, 0.08)',
                      border: '1px solid #ff4d4f',
                      borderRadius: '4px',
                      padding: '1px 8px',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    },
                  ]}
                  onClick={handleMergeFolders}>
                  <IconButton
                    iconStyle="far"
                    icon="compress-alt"
                    customStyle={{
                      color: '#ff4d4f',
                      fontSize: '14px',
                    }}
                    backgroundOff
                  />
                  <p
                    css={{
                      marginBottom: 0,
                      color: '#ff4d4f',
                      fontSize: '13.5px',
                      fontWeight: 500,
                    }}>
                    {intl.formatMessage({ id: 'merge' })}
                  </p>
                </div>
              </Tooltip>
            )}
            {newFoldersCount > 0 && (
              <div
                css={{
                  marginLeft: 4,
                  fontSize: 13,
                  color: '#faad14',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <FontAwesomeIcon
                  icon={['fas', 'circle']}
                  css={{ fontSize: 6, marginRight: 6 }}
                />
                {intl.formatMessage(
                  { id: 'unsaved-changes-count' },
                  { count: newFoldersCount }
                )}
              </div>
            )}
            {duplicateFoldersCount > 0 && (
              <div
                css={{
                  marginLeft: 4,
                  fontSize: 13,
                  color: '#ff4d4f',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <FontAwesomeIcon
                  icon={['fas', 'exclamation-circle']}
                  css={{ fontSize: 14, marginRight: 6 }}
                />
                {intl.formatMessage(
                  { id: 'duplicate-folders-error' },
                  { count: duplicateFoldersCount }
                )}
              </div>
            )}
          </div>
          <div css={{ display: 'flex', marginLeft: 'auto', gap: 8 }}>
            {/* CREATE NEW FOLDER */}
            <div
              css={style.buttonDiv}
              onClick={() => {
                window.dispatchEvent(new CustomEvent('openCreateFolderModal'));
              }}>
              <IconButton
                iconStyle="far"
                icon="folder-plus"
                customStyle={style.icons}
                backgroundOff
              />
              <p css={{ marginBottom: 0, marginLeft: 2 }}>
                {intl.formatMessage({ id: 'create-folder' })}
              </p>
            </div>
            {/* REORGANIZE FOLDERS - COMMENTED OUT */}
            {/*
            <Tooltip
              title={
                newFoldersCount === 0
                  ? intl.formatMessage({ id: 'no-folders-to-reorganize' })
                  : ''
              }
              placement="bottom">
              <div
                css={[
                  style.buttonDiv,
                  newFoldersCount === 0 && {
                    opacity: 0.5,
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                  },
                ]}
                onClick={() => {
                  if (newFoldersCount > 0) {
                    window.dispatchEvent(
                      new CustomEvent('openReorganizeFoldersModal')
                    );
                  }
                }}>
                <IconButton
                  iconStyle="far"
                  icon="folder-tree"
                  customStyle={style.icons}
                  backgroundOff
                />
                <p css={{ marginBottom: 0, marginLeft: 2 }}>
                  {intl.formatMessage({ id: 'reorganize' })}
                </p>
              </div>
            </Tooltip>
            */}
            {/* IMPORT TEMPLATE */}
            <div
              css={style.buttonDiv}
              onClick={() =>
                importTemplateModal.open({ mode: 'project-builder' })
              }>
              <IconButton
                iconStyle="far"
                icon="folder-upload"
                customStyle={style.icons}
                backgroundOff
              />
              <p css={{ marginBottom: 0, marginLeft: 2 }}>
                {intl.formatMessage({ id: 'import' })}
              </p>
            </div>
            {/* PROJECT BUILDER - COMMENTED OUT */}
            {/*
            <div
              css={style.buttonDiv}
              onClick={() => projectBuilderModal.open({})}>
              <IconButton
                iconStyle="fad"
                icon="sliders-h-square"
                customStyle={style.icons}
                backgroundOff
              />
              <p css={{ marginBottom: 0, marginLeft: 2 }}>
                {intl.formatMessage({ id: 'project-builder' })}
              </p>
            </div>
            */}
            {/* HELP ICON */}
            <IconButton
              icon={['far', 'info-circle']}
              customStyle={{ fontSize: '130%' }}
              containerStyle={{
                marginLeft: 8,
                color: '#7a829b',
              }}
              click={() => setHelpProjectBuilderModalVisible(true)}
              tooltip={intl.formatMessage({
                id: 'project-builder-help-tooltip',
              })}
            />
          </div>
        </Fragment>
      )}
      <CreateFolderModal
        visible={createModalVisible}
        parent={currentFolder}
        onCancel={() => setCreateModalVisible(false)}
      />
      <CreateTenderModal
        projectId={projectId}
        visible={createTenderModalVisible}
        onCancel={() => setCreateTenderModalVisible(false)}
      />
      <ProjectBuilderHelpInfoModal
        visible={isHelpProjectBuilderModalVisible}
        onClose={() => setHelpProjectBuilderModalVisible(false)}
        headerId="project-builder-help-header"
      />
    </div>
  );
};

export default RightSideNav;
